var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.848 6.039a2.39 2.39 0 0 1 2.39-2.39h7.002a2.39 2.39 0 0 1 2.39 2.39v5.655a2.39 2.39 0 0 1-2.39 2.39H5.238a2.39 2.39 0 0 1-2.39-2.39V6.04Zm2.39-1.38a1.38 1.38 0 0 0-1.38 1.38v5.655c0 .763.618 1.38 1.38 1.38h7.002a1.38 1.38 0 0 0 1.38-1.38V6.04a1.38 1.38 0 0 0-1.38-1.38H5.238Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.69 7.858a.168.168 0 0 0-.29.051l-.915 2.67a.168.168 0 0 0 .16.223h5.835a.168.168 0 0 0 .138-.266L10.42 8.842a.168.168 0 0 0-.26-.018l-.522.554c-.49.52-1.325.488-1.774-.068zm-1.245-.276a1.178 1.178 0 0 1 2.03-.359L8.65 8.676a.17.17 0 0 0 .254.01l.522-.555a1.18 1.18 0 0 1 1.82.128l1.197 1.694a1.178 1.178 0 0 1-.962 1.859H5.644A1.178 1.178 0 0 1 4.53 10.25l.916-2.67Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.104 6.591a.673.673 0 1 1-1.346 0 .673.673 0 0 1 1.346 0"
  })));
};
export default SvgGallery;